class ImageSequence extends HTMLElement {
    constructor() {
      super();
      this.images = ['transition-image-1', 'transition-image-2', 'transition-image-3'];
      this.currentIndex = 0;
      this.cycleImages = this.cycleImages.bind(this); // Bind to keep context
    }

    connectedCallback() {
      // Start cycling images
      this.interval = setInterval(this.cycleImages, 1000);
    }

    disconnectedCallback() {
      // Clear interval when element is removed
      clearInterval(this.interval);
    }

    cycleImages() {
      // Remove active class from all images
      this.images.forEach(image => document.getElementById(image).classList.remove('active'));

      // Add active class to the current image
      document.getElementById(this.images[this.currentIndex]).classList.add('active');

      // Move to the next image (loop back to start if necessary)
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }
  }

  // Define the custom element
if (!customElements.get('image-sequence')) {
  customElements.define('image-sequence', ImageSequence);
}
             